__turbopack_context__.v({
  "activeNavItem": "PremiumToolsNavigator-module__WJeLFG__activeNavItem",
  "activeQuickJump": "PremiumToolsNavigator-module__WJeLFG__activeQuickJump",
  "bgblue": "PremiumToolsNavigator-module__WJeLFG__bgblue",
  "bggreen": "PremiumToolsNavigator-module__WJeLFG__bggreen",
  "bgpink": "PremiumToolsNavigator-module__WJeLFG__bgpink",
  "bgpurple": "PremiumToolsNavigator-module__WJeLFG__bgpurple",
  "bgteal": "PremiumToolsNavigator-module__WJeLFG__bgteal",
  "bgyellow": "PremiumToolsNavigator-module__WJeLFG__bgyellow",
  "colorblue": "PremiumToolsNavigator-module__WJeLFG__colorblue",
  "colorgreen": "PremiumToolsNavigator-module__WJeLFG__colorgreen",
  "colorpink": "PremiumToolsNavigator-module__WJeLFG__colorpink",
  "colorpurple": "PremiumToolsNavigator-module__WJeLFG__colorpurple",
  "colorteal": "PremiumToolsNavigator-module__WJeLFG__colorteal",
  "coloryellow": "PremiumToolsNavigator-module__WJeLFG__coloryellow",
  "completeBadge": "PremiumToolsNavigator-module__WJeLFG__completeBadge",
  "container": "PremiumToolsNavigator-module__WJeLFG__container",
  "header": "PremiumToolsNavigator-module__WJeLFG__header",
  "headerContent": "PremiumToolsNavigator-module__WJeLFG__headerContent",
  "navArrow": "PremiumToolsNavigator-module__WJeLFG__navArrow",
  "navIcon": "PremiumToolsNavigator-module__WJeLFG__navIcon",
  "navItem": "PremiumToolsNavigator-module__WJeLFG__navItem",
  "navName": "PremiumToolsNavigator-module__WJeLFG__navName",
  "navScroll": "PremiumToolsNavigator-module__WJeLFG__navScroll",
  "navigation": "PremiumToolsNavigator-module__WJeLFG__navigation",
  "quickJump": "PremiumToolsNavigator-module__WJeLFG__quickJump",
  "quickJumpButton": "PremiumToolsNavigator-module__WJeLFG__quickJumpButton",
  "quickJumpButtons": "PremiumToolsNavigator-module__WJeLFG__quickJumpButtons",
  "quickJumpLabel": "PremiumToolsNavigator-module__WJeLFG__quickJumpLabel",
  "toolContent": "PremiumToolsNavigator-module__WJeLFG__toolContent",
  "toolCount": "PremiumToolsNavigator-module__WJeLFG__toolCount",
  "toolCountLabel": "PremiumToolsNavigator-module__WJeLFG__toolCountLabel",
  "toolCountNumber": "PremiumToolsNavigator-module__WJeLFG__toolCountNumber",
  "toolInfo": "PremiumToolsNavigator-module__WJeLFG__toolInfo",
  "toolInfoContent": "PremiumToolsNavigator-module__WJeLFG__toolInfoContent",
  "toolInfoDescription": "PremiumToolsNavigator-module__WJeLFG__toolInfoDescription",
  "toolInfoIcon": "PremiumToolsNavigator-module__WJeLFG__toolInfoIcon",
  "toolInfoName": "PremiumToolsNavigator-module__WJeLFG__toolInfoName",
  "toolInfoNav": "PremiumToolsNavigator-module__WJeLFG__toolInfoNav",
  "toolPosition": "PremiumToolsNavigator-module__WJeLFG__toolPosition",
});
